export default "__VITE_ASSET__d73a3bb6__"